/**
 * Machine-readable code from an API error body. Prefer it over the HTTP status, which routinely
 * covers several situations at once — a 403 can mean "lacks the permission" or "owned by someone
 * else". `$toast.error(error)` localizes a known code via the `error.code.*` keys.
 */
export function getApiErrorCode(error) {
  return error?.response?.data?.code ?? null;
}
